import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import whatInput from 'what-input';
import analytics from '@utils/analytics';
import api from '@utils/api';
import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import customEventBus from '@common/scripts/libs/eventBus';
import analyticsStone from '@stone/utils/analytics';
import ExpressPaymentItem from './ExpressPaymentItem';
import ExpressPaymentsButtons from './ExpressPaymentsButtons';
import { getId } from '@common/utils/brandDiffsUtils';
import GiftCardDisclaimer from '@moncler/components/product/GiftCardDisclaimer';
const ExpressPaymentsModal = (props) => {
    var _a;
    const { t } = useTranslation();
    const refButton = useRef(null);
    const [bag, setBag] = useState();
    const [paymentMethods, setPaymentMethods] = useState();
    const [adyenConfig, setAdyenConfig] = useState();
    const [modalExpressPaymentsOpen, setModalExpressPaymentsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const currentProduct = useMemo(() => { var _a; return `${props.currentId}${((_a = props.size) === null || _a === void 0 ? void 0 : _a.id) || ''}`; }, [props.currentId, props.size]);
    useEffect(() => {
        setBag(props.bag);
    }, [props.bag]);
    useEffect(() => {
        if (modalExpressPaymentsOpen) {
            api.getPaymentMethods().then((data) => setPaymentMethods(data));
            api.getAdyenConfig().then((data) => setAdyenConfig(data));
        }
    }, [modalExpressPaymentsOpen]);
    const modalOpen = useMemo(() => {
        return modalExpressPaymentsOpen && !!adyenConfig && !!paymentMethods && !!bag;
    }, [modalExpressPaymentsOpen, adyenConfig, paymentMethods, bag]);
    const buttonDisabled = useMemo(() => {
        var _a;
        if (((_a = bag === null || bag === void 0 ? void 0 : bag.items) === null || _a === void 0 ? void 0 : _a.find((el) => { var _a; return !el.available && !((_a = el === null || el === void 0 ? void 0 : el.availability) === null || _a === void 0 ? void 0 : _a.preorder); })) != undefined || (bag === null || bag === void 0 ? void 0 : bag.checkoutDisabled))
            return true;
        if (loading || modalExpressPaymentsOpen)
            return true;
        return false;
    }, [loading, modalExpressPaymentsOpen, bag]);
    const updateBag = () => {
        api.getMiniCart().then((data) => {
            if ((data === null || data === void 0 ? void 0 : data.items.length) == 0) {
                setModalExpressPaymentsOpen(false);
            }
            else {
                setBag(data);
            }
            customEventBus.emit('minicart:update', { fromKeyboard: whatInput.ask() === 'keyboard', pid: currentProduct });
        });
    };
    if ((props.currentId == undefined && !bag) || window.noguestcheckout || window.noexpresscheckout || (bag === null || bag === void 0 ? void 0 : bag.exchangeModel)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        (props.size == undefined || props.size.selectable) && (React.createElement(Button, { reference: refButton, cls: ['button--secondary'], type: 'button', disabled: buttonDisabled, onClick: () => {
                if (!props.size && props.currentId) {
                    console.log('no size, triggering size selector:', props.triggerOpenSize);
                    props.triggerOpenSize && props.triggerOpenSize();
                }
                else if (props.currentId) {
                    setLoading(true);
                    // PDP
                    api
                        .expressAddToCart(currentProduct)
                        .then((data) => {
                        setLoading(false);
                        setModalExpressPaymentsOpen(true);
                        customEventBus.emit('minicart:update', { fromKeyboard: whatInput.ask() === 'keyboard', pid: currentProduct });
                        setBag(data);
                    })
                        .catch((err) => {
                        console.info(err);
                        setLoading(false);
                        setModalExpressPaymentsOpen(false);
                    });
                }
                else {
                    // Cart page
                    if ((bag === null || bag === void 0 ? void 0 : bag.containsMbm) && !window.loggedin) {
                        props === null || props === void 0 ? void 0 : props.onLoginClick();
                    }
                    else {
                        analytics.checkoutTypeChose('shopping bag', 'express checkout');
                        setModalExpressPaymentsOpen(true);
                    }
                }
                if (getId() == 'ST') {
                    analyticsStone.expressCheckout('click', props.analyticsPage || 'pdp');
                }
            }, ariaHaspopup: 'dialog' }, t('checkout.expresscheckout'))),
        React.createElement(ModalDialog, { className: classNames({ cart: props.isCart }, 'expresspayment-modal modal--fixed-small'), isOpen: modalOpen, overlayClassName: "mobile-visible", onRequestClose: () => {
                analytics.checkoutTypeChose('shopping bag', 'close');
                setModalExpressPaymentsOpen(false);
            }, onAfterClose: () => {
                var _a;
                (_a = refButton.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, contentLabel: props.isCart ? t('checkout.expresscheckout') : t('checkout.expresscheckoutitems', { 0: bag === null || bag === void 0 ? void 0 : bag.numItems }), noPadding: props.modalNoPadding, fullWidth: props.modalFullWidth }, modalOpen && (React.createElement(React.Fragment, null,
            !props.isCart && !props.hideSummary && (React.createElement("div", { className: "product-box__list" }, (_a = bag === null || bag === void 0 ? void 0 : bag.items) === null || _a === void 0 ? void 0 : _a.map((item, i) => (React.createElement(ExpressPaymentItem, { key: item.UUID, item: item, onRemove: updateBag }))))),
            React.createElement("p", { className: "expresspayment-modal__intro" }, t('checkout.expresscheckoutintro')),
            React.createElement(GiftCardDisclaimer, { checkouturl: props.checkouturl, bag: bag }),
            React.createElement(ExpressPaymentsButtons, Object.assign({}, props, { adyenConfig: adyenConfig, paymentMethods: paymentMethods, bag: bag, fromModal: true, onBackPress: () => {
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById('expresscheckout-selectdesc')) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 200);
                }, analyticsStone: (payment) => {
                    analyticsStone.expressCheckout('submit', props.analyticsPage || 'pdp', payment);
                } })))))));
};
export default ExpressPaymentsModal;
